/* eslint-disable */
/// This file is auto generated - do not edit manually
export const ClubMatasPrice = 'Website.Product.PriceInfo.ClubMatasPrice';
export const NotClubMatasPrice = 'Website.Product.PriceInfo.NotClubMatasPrice';
export const NotClubMatasMember = 'Website.Product.PriceInfo.NotClubMatasMember';
export const PriceBefore = 'Website.Product.PriceInfo.PriceBefore';
export const YourDiscount = 'Website.Product.PriceInfo.YourDiscount';
export const Piece = 'Website.Product.PriceInfo.Piece';
export const Save = 'Website.Product.PriceInfo.Save';
